import { defineMessage, FormattedMessage, useIntl } from 'react-intl';
import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import { animated } from '@react-spring/web';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useMemo, useState, useCallback, useEffect } from 'react';
import { PropTypes as PropTypes$1 } from '@micromag/core';
import { ScreenElement, PlaceholderTitle } from '@micromag/core/components';
import { useScreenRenderContext, useViewerInteraction, usePlaybackContext, usePlaybackMediaRef, useScreenSize, useViewerContext, useScreenState } from '@micromag/core/contexts';
import { useTrackScreenEvent, useDragProgress } from '@micromag/core/hooks';
import { isTextFilled } from '@micromag/core/utils';
import Background from '@micromag/element-background';
import Button from '@micromag/element-button';
import Container from '@micromag/element-container';
import Heading from '@micromag/element-heading';
import Keypad from '@micromag/element-keypad';
import Layout from '@micromag/element-layout';
import Text from '@micromag/element-text';
import Author from '@micromag/element-urbania-author';
import aquarius from '../assets/images/38b67a045c917eba.png';
import aries from '../assets/images/f1d91f035ccb8c4f.png';
import cancer from '../assets/images/c2730eca851f3186.png';
import capricorn from '../assets/images/a6d606997910361a.png';
import gemini from '../assets/images/12148919dcf14f67.png';
import leo from '../assets/images/5ccc4bde48c478ee.png';
import libra from '../assets/images/d94c6aef4634d47f.png';
import pisces from '../assets/images/bc3a4d9747d9235c.png';
import sagittarius from '../assets/images/4aec8c7b2b1f6739.png';
import scorpio from '../assets/images/01b9ca612cf4a6a6.png';
import taurus from '../assets/images/3a3a4d27b9a019b2.png';
import virgo from '../assets/images/f3452bab9d2d80d5.png';
import aquariusThumbnail from '../assets/images/f82faebe2d495394.png';
import ariesThumbnail from '../assets/images/ddafd58fab0d5925.png';
import cancerThumbnail from '../assets/images/7d6b81c3035f5968.png';
import capricornThumbnail from '../assets/images/422146a5faadb139.png';
import geminiThumbnail from '../assets/images/ead69accd3f76ece.png';
import leoThumbnail from '../assets/images/36c18c31d1e80a70.png';
import libraThumbnail from '../assets/images/ef219f6696d5ce04.png';
import piscesThumbnail from '../assets/images/f21db7431692d889.png';
import sagittariusThumbnail from '../assets/images/0964d576c4c1da6d.png';
import scorpioThumbnail from '../assets/images/1ffa37309c1fbcfa.png';
import taurusThumbnail from '../assets/images/822018b354054d62.png';
import virgoThumbnail from '../assets/images/b3e1e35461e78e82.png';
import Scroll from '@micromag/element-scroll';

var signs = [{
  id: 'aries',
  image: aries,
  thumbnail: ariesThumbnail,
  label: defineMessage({
    id: "/PJA/1",
    defaultMessage: [{
      "type": 0,
      "value": "Aries"
    }]
  }),
  date: defineMessage({
    id: "ZeosMy",
    defaultMessage: [{
      "type": 0,
      "value": "Mar 21 - Apr 19"
    }]
  })
}, {
  id: 'taurus',
  image: taurus,
  thumbnail: taurusThumbnail,
  label: defineMessage({
    id: "XKcyqx",
    defaultMessage: [{
      "type": 0,
      "value": "Taurus"
    }]
  }),
  date: defineMessage({
    id: "raUY02",
    defaultMessage: [{
      "type": 0,
      "value": "Apr 20 - May 20"
    }]
  })
}, {
  id: 'gemini',
  image: gemini,
  thumbnail: geminiThumbnail,
  label: defineMessage({
    id: "4g35M0",
    defaultMessage: [{
      "type": 0,
      "value": "Gemini"
    }]
  }),
  date: defineMessage({
    id: "142Fjj",
    defaultMessage: [{
      "type": 0,
      "value": "May 21 - June 20"
    }]
  })
}, {
  id: 'cancer',
  image: cancer,
  thumbnail: cancerThumbnail,
  label: defineMessage({
    id: "0acGK7",
    defaultMessage: [{
      "type": 0,
      "value": "Cancer"
    }]
  }),
  date: defineMessage({
    id: "bMdONM",
    defaultMessage: [{
      "type": 0,
      "value": "June 21 - July 22"
    }]
  })
}, {
  id: 'leo',
  image: leo,
  thumbnail: leoThumbnail,
  label: defineMessage({
    id: "EEUc6n",
    defaultMessage: [{
      "type": 0,
      "value": "Leo"
    }]
  }),
  date: defineMessage({
    id: "MBgLeH",
    defaultMessage: [{
      "type": 0,
      "value": "July 23 - Aug 22"
    }]
  })
}, {
  id: 'virgo',
  image: virgo,
  thumbnail: virgoThumbnail,
  label: defineMessage({
    id: "6bd963",
    defaultMessage: [{
      "type": 0,
      "value": "Virgo"
    }]
  }),
  date: defineMessage({
    id: "xL0GD2",
    defaultMessage: [{
      "type": 0,
      "value": "Aug 23 - Sept 22"
    }]
  })
}, {
  id: 'libra',
  image: libra,
  thumbnail: libraThumbnail,
  label: defineMessage({
    id: "M/FGRs",
    defaultMessage: [{
      "type": 0,
      "value": "Libra"
    }]
  }),
  date: defineMessage({
    id: "F0QDfY",
    defaultMessage: [{
      "type": 0,
      "value": "Sept 23 - Oct 22"
    }]
  })
}, {
  id: 'scorpio',
  image: scorpio,
  thumbnail: scorpioThumbnail,
  label: defineMessage({
    id: "YyPYHk",
    defaultMessage: [{
      "type": 0,
      "value": "Scorpio"
    }]
  }),
  date: defineMessage({
    id: "7ZzlUE",
    defaultMessage: [{
      "type": 0,
      "value": "Oct 23 - Nov 22"
    }]
  })
}, {
  id: 'sagittarius',
  image: sagittarius,
  thumbnail: sagittariusThumbnail,
  label: defineMessage({
    id: "7mMPO4",
    defaultMessage: [{
      "type": 0,
      "value": "Sagittarius"
    }]
  }),
  date: defineMessage({
    id: "yCj5uv",
    defaultMessage: [{
      "type": 0,
      "value": "Nov 23 - Dec 21"
    }]
  })
}, {
  id: 'capricorn',
  image: capricorn,
  thumbnail: capricornThumbnail,
  label: defineMessage({
    id: "NumcrW",
    defaultMessage: [{
      "type": 0,
      "value": "Capricorn"
    }]
  }),
  date: defineMessage({
    id: "rAkTvt",
    defaultMessage: [{
      "type": 0,
      "value": "Dec 22 - Jan 20"
    }]
  })
}, {
  id: 'aquarius',
  image: aquarius,
  thumbnail: aquariusThumbnail,
  label: defineMessage({
    id: "fBii8l",
    defaultMessage: [{
      "type": 0,
      "value": "Aquarius"
    }]
  }),
  date: defineMessage({
    id: "Op1ZIp",
    defaultMessage: [{
      "type": 0,
      "value": "Jan 21 - Feb 18"
    }]
  })
}, {
  id: 'pisces',
  image: pisces,
  thumbnail: piscesThumbnail,
  label: defineMessage({
    id: "dxAumJ",
    defaultMessage: [{
      "type": 0,
      "value": "Pisces"
    }]
  }),
  date: defineMessage({
    id: "Evl2dG",
    defaultMessage: [{
      "type": 0,
      "value": "Feb 19 - Mar 20"
    }]
  })
}];

var styles$2 = {"container":"micromag-screen-urbania-horoscope-sign-card-container","placeholder":"micromag-screen-urbania-horoscope-sign-card-placeholder","thumbnail":"micromag-screen-urbania-horoscope-sign-card-thumbnail","name":"micromag-screen-urbania-horoscope-sign-card-name","date":"micromag-screen-urbania-horoscope-sign-card-date","emptyText":"micromag-screen-urbania-horoscope-sign-card-emptyText"};

var propTypes$2 = {
  className: PropTypes.string,
  sign: PropTypes.shape({
    id: PropTypes.string,
    label: PropTypes$1.textElement,
    date: PropTypes$1.message,
    thumbnail: PropTypes.string,
    word: PropTypes$1.headingElement,
    description: PropTypes$1.textElement
  }),
  focusable: PropTypes.bool,
  onClick: PropTypes.func
};
var defaultProps$2 = {
  className: null,
  sign: null,
  focusable: true,
  onClick: null
};
var SignCard = function SignCard(_ref) {
  var className = _ref.className,
    sign = _ref.sign,
    focusable = _ref.focusable,
    onClick = _ref.onClick;
  var _ref2 = sign || {},
    _ref2$id = _ref2.id,
    id = _ref2$id === void 0 ? null : _ref2$id,
    _ref2$thumbnail = _ref2.thumbnail,
    thumbnail = _ref2$thumbnail === void 0 ? null : _ref2$thumbnail,
    _ref2$label = _ref2.label,
    label = _ref2$label === void 0 ? null : _ref2$label,
    _ref2$date = _ref2.date,
    date = _ref2$date === void 0 ? null : _ref2$date;
  return /*#__PURE__*/React.createElement(ScreenElement, {
    placeholder: /*#__PURE__*/React.createElement(PlaceholderTitle, {
      className: styles$2.placeholder
    }),
    emptyLabel: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "ceaRdq",
      defaultMessage: [{
        "type": 0,
        "value": "Horoscope sign"
      }]
    }),
    emptyClassName: styles$2.emptyText,
    isEmpty: !id
  }, /*#__PURE__*/React.createElement("button", {
    className: classNames([styles$2.container, _defineProperty({}, className, className !== null)]),
    type: "button",
    tabIndex: focusable ? '0' : -1,
    onClick: onClick
  }, thumbnail !== null ? /*#__PURE__*/React.createElement("img", {
    className: styles$2.thumbnail,
    src: thumbnail,
    alt: id,
    loading: "lazy"
  }) : null, /*#__PURE__*/React.createElement("div", {
    className: styles$2.gridText
  }, /*#__PURE__*/React.createElement("h2", {
    className: styles$2.name
  }, label !== null ? /*#__PURE__*/React.createElement(FormattedMessage, label) : null), /*#__PURE__*/React.createElement("p", {
    className: styles$2.date
  }, date !== null ? /*#__PURE__*/React.createElement(FormattedMessage, date) : null))));
};
SignCard.propTypes = propTypes$2;
SignCard.defaultProps = defaultProps$2;

var styles$1 = {"modalButton":"micromag-screen-urbania-horoscope-sign-modal-modalButton","container":"micromag-screen-urbania-horoscope-sign-modal-container","modal":"micromag-screen-urbania-horoscope-sign-modal-modal","name":"micromag-screen-urbania-horoscope-sign-modal-name","wordContainer":"micromag-screen-urbania-horoscope-sign-modal-wordContainer","wordOfTheWeek":"micromag-screen-urbania-horoscope-sign-modal-wordOfTheWeek","word":"micromag-screen-urbania-horoscope-sign-modal-word","description":"micromag-screen-urbania-horoscope-sign-modal-description","illustration":"micromag-screen-urbania-horoscope-sign-modal-illustration"};

var propTypes$1 = {
  width: PropTypes.number,
  height: PropTypes.number,
  sign: PropTypes.shape({
    id: PropTypes.string,
    label: PropTypes$1.textElement,
    date: PropTypes$1.message,
    image: PropTypes.string,
    word: PropTypes$1.headingElement,
    description: PropTypes$1.textElement
  }),
  subtitle: PropTypes$1.headingElement,
  current: PropTypes.bool,
  transitionDisabled: PropTypes.bool,
  focusable: PropTypes.bool,
  onClick: PropTypes.func,
  className: PropTypes.string
};
var defaultProps$1 = {
  width: null,
  height: null,
  sign: null,
  subtitle: null,
  current: true,
  transitionDisabled: false,
  focusable: true,
  onClick: null,
  className: null
};
var SignModal = function SignModal(_ref) {
  var width = _ref.width,
    height = _ref.height,
    sign = _ref.sign,
    subtitle = _ref.subtitle,
    current = _ref.current,
    transitionDisabled = _ref.transitionDisabled,
    focusable = _ref.focusable,
    _onClick = _ref.onClick,
    className = _ref.className;
  // eslint-disable-next-line no-unused-vars
  var _ref2 = sign || {},
    _ref2$label = _ref2.label,
    label = _ref2$label === void 0 ? null : _ref2$label,
    _ref2$image = _ref2.image,
    image = _ref2$image === void 0 ? null : _ref2$image;
    _ref2.date;
    var _ref2$word = _ref2.word,
    word = _ref2$word === void 0 ? null : _ref2$word,
    _ref2$description = _ref2.description,
    description = _ref2$description === void 0 ? null : _ref2$description;
  // const { body: wordBody = null } = word || {};

  var _useScreenRenderConte = useScreenRenderContext(),
    isEdit = _useScreenRenderConte.isEdit;
  var hasWord = isTextFilled(word);
  var hasSubtitle = isTextFilled(subtitle);
  var scrollingDisabled = !isEdit && transitionDisabled || !current;
  return /*#__PURE__*/React.createElement(Container, {
    width: width,
    height: height,
    className: classNames([styles$1.container, _defineProperty(_defineProperty({}, styles$1.withoutTransitions, transitionDisabled), className, className !== null)])
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: styles$1.modalButton,
    tabIndex: focusable ? '0' : '-1',
    onClick: function onClick(e) {
      if (_onClick !== null) {
        _onClick(e);
      }
    }
  }, /*#__PURE__*/React.createElement(Scroll, {
    disabled: scrollingDisabled,
    verticalAlign: "middle"
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$1.modal
  }, label !== null ? /*#__PURE__*/React.createElement(ScreenElement, null, /*#__PURE__*/React.createElement("h2", {
    className: styles$1.name
  }, /*#__PURE__*/React.createElement(FormattedMessage, label))) : null, hasWord ? /*#__PURE__*/React.createElement("div", {
    className: styles$1.wordContainer
  }, hasSubtitle ? /*#__PURE__*/React.createElement(Heading, Object.assign({
    className: styles$1.wordOfTheWeek
  }, subtitle)) : /*#__PURE__*/React.createElement("h3", {
    className: styles$1.wordOfTheWeek
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "+vzDdb",
    defaultMessage: [{
      "type": 0,
      "value": "Word of the Week"
    }]
  })), /*#__PURE__*/React.createElement(Text, Object.assign({
    className: styles$1.word
  }, word))) : null, description ? /*#__PURE__*/React.createElement(Text, Object.assign({
    className: styles$1.description
  }, description)) : null, image ? /*#__PURE__*/React.createElement("img", {
    className: styles$1.illustration,
    src: image,
    alt: label
  }) : null))));
};
SignModal.propTypes = propTypes$1;
SignModal.defaultProps = defaultProps$1;

var styles = {"close":"micromag-screen-urbania-horoscope-close","backdrop":"micromag-screen-urbania-horoscope-backdrop","signsGridContainer":"micromag-screen-urbania-horoscope-signsGridContainer","container":"micromag-screen-urbania-horoscope-container","background":"micromag-screen-urbania-horoscope-background","content":"micromag-screen-urbania-horoscope-content","emptyText":"micromag-screen-urbania-horoscope-emptyText","isPlaceholder":"micromag-screen-urbania-horoscope-isPlaceholder","layout":"micromag-screen-urbania-horoscope-layout","placeholderGrid":"micromag-screen-urbania-horoscope-placeholderGrid","placeholderItem":"micromag-screen-urbania-horoscope-placeholderItem","headerContainer":"micromag-screen-urbania-horoscope-headerContainer","title":"micromag-screen-urbania-horoscope-title","titleImage":"micromag-screen-urbania-horoscope-titleImage","description":"micromag-screen-urbania-horoscope-description","button":"micromag-screen-urbania-horoscope-button","buttonLabel":"micromag-screen-urbania-horoscope-buttonLabel","header":"micromag-screen-urbania-horoscope-header","buttons":"micromag-screen-urbania-horoscope-buttons","author":"micromag-screen-urbania-horoscope-author","collaborator":"micromag-screen-urbania-horoscope-collaborator","authorBackground":"micromag-screen-urbania-horoscope-authorBackground","modal":"micromag-screen-urbania-horoscope-modal"};

var Astrologie = "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20906.64%20139.48%22%3E%20%20%20%20%3Cpath%20d%3D%22M35.88%2C4.42h35.5l34.66%2C119.78h-28.43l-5.89-23.72H35.55l-6.22%2C23.72H1.4L35.88%2C4.42Zm31.8%2C75.54l-13.63-52.15h-.34l-14.13%2C52.15h28.09Z%22%20fill%3D%22%23000f66%22%20stroke%3D%22aqua%22%20stroke-miterlimit%3D%2210%22%20stroke-width%3D%222.1%22%2F%3E%20%20%20%20%3Cpath%20d%3D%22M123.37%2C122.51c-6.84-3.36-12.17-8.13-15.98-14.3-3.81-6.17-5.78-13.34-5.89-21.53l26.24-4.21c0%2C7.07%2C1.96%2C12.73%2C5.89%2C16.99%2C3.92%2C4.26%2C8.92%2C6.39%2C14.97%2C6.39%2C4.82%2C0%2C8.72-1.29%2C11.69-3.87%2C2.97-2.58%2C4.46-5.89%2C4.46-9.92%2C0-3.37-1.15-6.2-3.45-8.5-2.3-2.3-6.03-4.34-11.19-6.14l-14.64-4.71c-10.66-3.25-18.37-7.68-23.13-13.29-4.77-5.61-7.15-13.01-7.15-22.21%2C0-10.88%2C3.53-19.63%2C10.6-26.24%2C7.07-6.62%2C16.99-9.93%2C29.78-9.93%2C11.89%2C0%2C21.48%2C3.23%2C28.77%2C9.67%2C7.29%2C6.45%2C11.05%2C15.17%2C11.27%2C26.16l-25.57%2C4.88c.11-5.83-1.24-10.51-4.04-14.05-2.8-3.53-6.45-5.3-10.94-5.3-3.93%2C0-7.12%2C1.21-9.59%2C3.62-2.47%2C2.41-3.7%2C5.47-3.7%2C9.17s1.15%2C6.54%2C3.45%2C8.83c2.3%2C2.3%2C6.08%2C4.23%2C11.36%2C5.8l13.96%2C4.71c10.88%2C3.25%2C18.76%2C7.66%2C23.64%2C13.21s7.32%2C12.93%2C7.32%2C22.12c0%2C7.29-1.74%2C13.79-5.22%2C19.51-3.48%2C5.72-8.52%2C10.18-15.14%2C13.38-6.62%2C3.2-14.58%2C4.79-23.89%2C4.79s-17.05-1.68-23.89-5.05Z%22%20fill%3D%22%23000f66%22%20stroke%3D%22aqua%22%20stroke-miterlimit%3D%2210%22%20stroke-width%3D%222.1%22%2F%3E%20%20%20%20%3Cpath%20d%3D%22M213.03%2C28.64h-28.26V4.42h84.96V28.64h-28.26V124.2h-28.43V28.64Z%22%20fill%3D%22%23000f66%22%20stroke%3D%22aqua%22%20stroke-miterlimit%3D%2210%22%20stroke-width%3D%222.1%22%2F%3E%20%20%20%20%3Cpath%20d%3D%22M335.5%2C122.35c-3.59-3.25-5.95-7.63-7.07-13.12l-5.05-21.37c-.79-2.92-2.19-5.3-4.21-7.15s-4.26-2.78-6.73-2.78h-10.09v46.26h-28.26V4.42h46.1c8.86%2C0%2C16.6%2C1.54%2C23.22%2C4.63%2C6.62%2C3.09%2C11.72%2C7.46%2C15.31%2C13.12%2C3.59%2C5.66%2C5.38%2C12.31%2C5.38%2C19.94%2C0%2C7.18-2.08%2C13.6-6.22%2C19.26-4.15%2C5.67-9.76%2C9.51-16.82%2C11.52v.17c2.8%2C1.24%2C4.96%2C3%2C6.48%2C5.3%2C1.51%2C2.3%2C2.66%2C5.13%2C3.45%2C8.5l3.53%2C15.48c.67%2C3.7%2C2.19%2C5.55%2C4.54%2C5.55%2C2.13%2C0%2C4.15-1.29%2C6.06-3.87l6.73%2C13.63c-2.8%2C2.92-6.2%2C5.24-10.18%2C6.98-3.98%2C1.74-8.05%2C2.61-12.2%2C2.61-5.72%2C0-10.38-1.63-13.96-4.88Zm-16.82-64.26c5.05%2C0%2C9.14-1.46%2C12.28-4.37%2C3.14-2.92%2C4.71-6.78%2C4.71-11.61%2C0-5.16-1.54-9.17-4.63-12.03-3.09-2.86-7.21-4.29-12.37-4.29h-16.32V58.08h16.32Z%22%20fill%3D%22%23000f66%22%20stroke%3D%22aqua%22%20stroke-miterlimit%3D%2210%22%20stroke-width%3D%222.1%22%2F%3E%20%20%20%20%3Cpath%20d%3D%22M396.23%2C119.74c-8.52-5.21-15.14-12.62-19.85-22.21-4.71-9.59-7.07-20.66-7.07-33.23s2.36-23.64%2C7.07-33.23c4.71-9.59%2C11.33-16.99%2C19.85-22.21%2C8.52-5.21%2C18.45-7.82%2C29.78-7.82s21.28%2C2.61%2C29.86%2C7.82c8.58%2C5.22%2C15.22%2C12.59%2C19.94%2C22.12%2C4.71%2C9.53%2C7.07%2C20.58%2C7.07%2C33.14s-2.36%2C23.8-7.07%2C33.39c-4.71%2C9.59-11.36%2C16.99-19.94%2C22.21s-18.53%2C7.82-29.86%2C7.82-21.26-2.61-29.78-7.82Zm50.47-27c5.16-7.07%2C7.74-16.54%2C7.74-28.43s-2.58-21.37-7.74-28.43c-5.16-7.07-12.06-10.6-20.69-10.6s-15.51%2C3.53-20.61%2C10.6c-5.1%2C7.07-7.65%2C16.54-7.65%2C28.43s2.55%2C21.37%2C7.65%2C28.43c5.1%2C7.07%2C11.97%2C10.6%2C20.61%2C10.6s15.53-3.53%2C20.69-10.6Z%22%20fill%3D%22%23000f66%22%20stroke%3D%22aqua%22%20stroke-miterlimit%3D%2210%22%20stroke-width%3D%222.1%22%2F%3E%20%20%20%20%3Cpath%20d%3D%22M489.26%2C4.42h28.26V99.97h37.68v24.23h-65.95V4.42Z%22%20fill%3D%22%23000f66%22%20stroke%3D%22aqua%22%20stroke-miterlimit%3D%2210%22%20stroke-width%3D%222.1%22%2F%3E%20%20%20%20%3Cpath%20d%3D%22M580.28%2C119.74c-8.52-5.21-15.14-12.62-19.85-22.21-4.71-9.59-7.07-20.66-7.07-33.23s2.36-23.64%2C7.07-33.23c4.71-9.59%2C11.33-16.99%2C19.85-22.21%2C8.52-5.21%2C18.45-7.82%2C29.78-7.82s21.28%2C2.61%2C29.86%2C7.82c8.58%2C5.22%2C15.22%2C12.59%2C19.94%2C22.12%2C4.71%2C9.53%2C7.07%2C20.58%2C7.07%2C33.14s-2.36%2C23.8-7.07%2C33.39c-4.71%2C9.59-11.36%2C16.99-19.94%2C22.21s-18.53%2C7.82-29.86%2C7.82-21.26-2.61-29.78-7.82Zm50.47-27c5.16-7.07%2C7.74-16.54%2C7.74-28.43s-2.58-21.37-7.74-28.43c-5.16-7.07-12.06-10.6-20.69-10.6s-15.51%2C3.53-20.61%2C10.6c-5.1%2C7.07-7.65%2C16.54-7.65%2C28.43s2.55%2C21.37%2C7.65%2C28.43c5.1%2C7.07%2C11.97%2C10.6%2C20.61%2C10.6s15.53-3.53%2C20.69-10.6Z%22%20fill%3D%22%23000f66%22%20stroke%3D%22aqua%22%20stroke-miterlimit%3D%2210%22%20stroke-width%3D%222.1%22%2F%3E%20%20%20%20%3Cpath%20d%3D%22M693.75%2C119.65c-7.68-5.05-13.6-12.31-17.75-21.79-4.15-9.48-6.22-20.66-6.22-33.56s2.21-24.25%2C6.65-33.73c4.43-9.48%2C10.77-16.77%2C19.01-21.87%2C8.24-5.1%2C17.97-7.65%2C29.19-7.65s21.53%2C3.28%2C29.95%2C9.84c8.41%2C6.56%2C14.19%2C15.56%2C17.33%2C27l-26.58%2C5.72c-1.8-5.72-4.54-10.2-8.24-13.46-3.7-3.25-7.96-4.88-12.79-4.88-8.08%2C0-14.44%2C3.42-19.09%2C10.26-4.66%2C6.84-6.98%2C16.21-6.98%2C28.09s2.63%2C21.84%2C7.91%2C28.85c5.27%2C7.01%2C12.5%2C10.51%2C21.7%2C10.51%2C8.19%2C0%2C14.66-2.49%2C19.43-7.49%2C4.77-4.99%2C7.26-11.92%2C7.49-20.78h-37.18v-18.51h64.26V124.2h-20.86l-1.68-18.67h-.17c-3.93%2C6.73-9.31%2C12.03-16.15%2C15.9-6.84%2C3.87-14.19%2C5.8-22.04%2C5.8-10.43%2C0-19.49-2.52-27.17-7.57Z%22%20fill%3D%22%23000f66%22%20stroke%3D%22aqua%22%20stroke-miterlimit%3D%2210%22%20stroke-width%3D%222.1%22%2F%3E%20%20%20%20%3Cpath%20d%3D%22M789.56%2C4.42h28.26V124.2h-28.26V4.42Z%22%20fill%3D%22%23000f66%22%20stroke%3D%22aqua%22%20stroke-miterlimit%3D%2210%22%20stroke-width%3D%222.1%22%2F%3E%20%20%20%20%3Cpath%20d%3D%22M827.74%2C4.42h68.81V27.13h-41.55v25.57h34.82v20.19h-34.82v28.6h43.24v22.71h-70.49V4.42Z%22%20fill%3D%22%23000f66%22%20stroke%3D%22aqua%22%20stroke-miterlimit%3D%2210%22%20stroke-width%3D%222.1%22%2F%3E%20%20%20%20%3Cpath%20d%3D%22M43.24%2C15.29h35.5l34.66%2C119.78h-28.43l-5.89-23.72H42.91l-6.22%2C23.72H8.76L43.24%2C15.29Zm31.8%2C75.54l-13.63-52.15h-.34l-14.13%2C52.15h28.09Z%22%20fill%3D%22aqua%22%20stroke%3D%22%23000f66%22%20stroke-miterlimit%3D%2210%22%20stroke-width%3D%222.1%22%2F%3E%20%20%20%20%3Cpath%20d%3D%22M130.73%2C133.38c-6.84-3.36-12.17-8.13-15.98-14.3-3.81-6.17-5.78-13.34-5.89-21.53l26.24-4.21c0%2C7.07%2C1.96%2C12.73%2C5.89%2C16.99%2C3.92%2C4.26%2C8.92%2C6.39%2C14.97%2C6.39%2C4.82%2C0%2C8.72-1.29%2C11.69-3.87%2C2.97-2.58%2C4.46-5.89%2C4.46-9.92%2C0-3.37-1.15-6.2-3.45-8.5-2.3-2.3-6.03-4.34-11.19-6.14l-14.64-4.71c-10.66-3.25-18.37-7.68-23.13-13.29-4.77-5.61-7.15-13.01-7.15-22.21%2C0-10.88%2C3.53-19.63%2C10.6-26.24%2C7.07-6.62%2C16.99-9.93%2C29.78-9.93%2C11.89%2C0%2C21.48%2C3.23%2C28.77%2C9.67%2C7.29%2C6.45%2C11.05%2C15.17%2C11.27%2C26.16l-25.57%2C4.88c.11-5.83-1.24-10.51-4.04-14.05-2.8-3.53-6.45-5.3-10.94-5.3-3.93%2C0-7.12%2C1.21-9.59%2C3.62-2.47%2C2.41-3.7%2C5.47-3.7%2C9.17s1.15%2C6.54%2C3.45%2C8.83c2.3%2C2.3%2C6.08%2C4.23%2C11.36%2C5.8l13.96%2C4.71c10.88%2C3.25%2C18.76%2C7.66%2C23.64%2C13.21s7.32%2C12.93%2C7.32%2C22.12c0%2C7.29-1.74%2C13.79-5.22%2C19.51-3.48%2C5.72-8.52%2C10.18-15.14%2C13.38-6.62%2C3.2-14.58%2C4.79-23.89%2C4.79s-17.05-1.68-23.89-5.05Z%22%20fill%3D%22aqua%22%20stroke%3D%22%23000f66%22%20stroke-miterlimit%3D%2210%22%20stroke-width%3D%222.1%22%2F%3E%20%20%20%20%3Cpath%20d%3D%22M220.39%2C39.51h-28.26V15.29h84.96v24.23h-28.26v95.56h-28.43V39.51Z%22%20fill%3D%22aqua%22%20stroke%3D%22%23000f66%22%20stroke-miterlimit%3D%2210%22%20stroke-width%3D%222.1%22%2F%3E%20%20%20%20%3Cpath%20d%3D%22M342.86%2C133.22c-3.59-3.25-5.95-7.63-7.07-13.12l-5.05-21.37c-.79-2.92-2.19-5.3-4.21-7.15s-4.26-2.78-6.73-2.78h-10.09v46.26h-28.26V15.29h46.1c8.86%2C0%2C16.6%2C1.54%2C23.22%2C4.63%2C6.62%2C3.09%2C11.72%2C7.46%2C15.31%2C13.12%2C3.59%2C5.66%2C5.38%2C12.31%2C5.38%2C19.94%2C0%2C7.18-2.08%2C13.6-6.22%2C19.26-4.15%2C5.67-9.76%2C9.51-16.82%2C11.52v.17c2.8%2C1.24%2C4.96%2C3%2C6.48%2C5.3%2C1.51%2C2.3%2C2.66%2C5.13%2C3.45%2C8.5l3.53%2C15.48c.67%2C3.7%2C2.19%2C5.55%2C4.54%2C5.55%2C2.13%2C0%2C4.15-1.29%2C6.06-3.87l6.73%2C13.63c-2.8%2C2.92-6.2%2C5.24-10.18%2C6.98-3.98%2C1.74-8.05%2C2.61-12.2%2C2.61-5.72%2C0-10.38-1.63-13.96-4.88Zm-16.82-64.26c5.05%2C0%2C9.14-1.46%2C12.28-4.37%2C3.14-2.92%2C4.71-6.78%2C4.71-11.61%2C0-5.16-1.54-9.17-4.63-12.03-3.09-2.86-7.21-4.29-12.37-4.29h-16.32v32.3h16.32Z%22%20fill%3D%22aqua%22%20stroke%3D%22%23000f66%22%20stroke-miterlimit%3D%2210%22%20stroke-width%3D%222.1%22%2F%3E%20%20%20%20%3Cpath%20d%3D%22M403.59%2C130.61c-8.52-5.21-15.14-12.62-19.85-22.21-4.71-9.59-7.07-20.66-7.07-33.23s2.36-23.64%2C7.07-33.23c4.71-9.59%2C11.33-16.99%2C19.85-22.21%2C8.52-5.21%2C18.45-7.82%2C29.78-7.82s21.28%2C2.61%2C29.86%2C7.82c8.58%2C5.22%2C15.22%2C12.59%2C19.94%2C22.12%2C4.71%2C9.53%2C7.07%2C20.58%2C7.07%2C33.14s-2.36%2C23.8-7.07%2C33.39c-4.71%2C9.59-11.36%2C16.99-19.94%2C22.21s-18.53%2C7.82-29.86%2C7.82-21.26-2.61-29.78-7.82Zm50.47-27c5.16-7.07%2C7.74-16.54%2C7.74-28.43s-2.58-21.37-7.74-28.43c-5.16-7.07-12.06-10.6-20.69-10.6s-15.51%2C3.53-20.61%2C10.6c-5.1%2C7.07-7.65%2C16.54-7.65%2C28.43s2.55%2C21.37%2C7.65%2C28.43c5.1%2C7.07%2C11.97%2C10.6%2C20.61%2C10.6s15.53-3.53%2C20.69-10.6Z%22%20fill%3D%22aqua%22%20stroke%3D%22%23000f66%22%20stroke-miterlimit%3D%2210%22%20stroke-width%3D%222.1%22%2F%3E%20%20%20%20%3Cpath%20d%3D%22M496.62%2C15.29h28.26V110.84h37.68v24.23h-65.95V15.29Z%22%20fill%3D%22aqua%22%20stroke%3D%22%23000f66%22%20stroke-miterlimit%3D%2210%22%20stroke-width%3D%222.1%22%2F%3E%20%20%20%20%3Cpath%20d%3D%22M587.64%2C130.61c-8.52-5.21-15.14-12.62-19.85-22.21-4.71-9.59-7.07-20.66-7.07-33.23s2.36-23.64%2C7.07-33.23c4.71-9.59%2C11.33-16.99%2C19.85-22.21%2C8.52-5.21%2C18.45-7.82%2C29.78-7.82s21.28%2C2.61%2C29.86%2C7.82c8.58%2C5.22%2C15.22%2C12.59%2C19.94%2C22.12%2C4.71%2C9.53%2C7.07%2C20.58%2C7.07%2C33.14s-2.36%2C23.8-7.07%2C33.39c-4.71%2C9.59-11.36%2C16.99-19.94%2C22.21s-18.53%2C7.82-29.86%2C7.82-21.26-2.61-29.78-7.82Zm50.47-27c5.16-7.07%2C7.74-16.54%2C7.74-28.43s-2.58-21.37-7.74-28.43c-5.16-7.07-12.06-10.6-20.69-10.6s-15.51%2C3.53-20.61%2C10.6c-5.1%2C7.07-7.65%2C16.54-7.65%2C28.43s2.55%2C21.37%2C7.65%2C28.43c5.1%2C7.07%2C11.97%2C10.6%2C20.61%2C10.6s15.53-3.53%2C20.69-10.6Z%22%20fill%3D%22aqua%22%20stroke%3D%22%23000f66%22%20stroke-miterlimit%3D%2210%22%20stroke-width%3D%222.1%22%2F%3E%20%20%20%20%3Cpath%20d%3D%22M701.11%2C130.53c-7.68-5.05-13.6-12.31-17.75-21.79-4.15-9.48-6.22-20.66-6.22-33.56s2.21-24.25%2C6.65-33.73c4.43-9.48%2C10.77-16.77%2C19.01-21.87%2C8.24-5.1%2C17.97-7.65%2C29.19-7.65s21.53%2C3.28%2C29.95%2C9.84c8.41%2C6.56%2C14.19%2C15.56%2C17.33%2C27l-26.58%2C5.72c-1.8-5.72-4.54-10.2-8.24-13.46-3.7-3.25-7.96-4.88-12.79-4.88-8.08%2C0-14.44%2C3.42-19.09%2C10.26-4.66%2C6.84-6.98%2C16.21-6.98%2C28.09s2.63%2C21.84%2C7.91%2C28.85c5.27%2C7.01%2C12.5%2C10.51%2C21.7%2C10.51%2C8.19%2C0%2C14.66-2.49%2C19.43-7.49%2C4.77-4.99%2C7.26-11.92%2C7.49-20.78h-37.18v-18.51h64.26v67.97h-20.86l-1.68-18.67h-.17c-3.93%2C6.73-9.31%2C12.03-16.15%2C15.9-6.84%2C3.87-14.19%2C5.8-22.04%2C5.8-10.43%2C0-19.49-2.52-27.17-7.57Z%22%20fill%3D%22aqua%22%20stroke%3D%22%23000f66%22%20stroke-miterlimit%3D%2210%22%20stroke-width%3D%222.1%22%2F%3E%20%20%20%20%3Cpath%20d%3D%22M796.92%2C15.29h28.26v119.78h-28.26V15.29Z%22%20fill%3D%22aqua%22%20stroke%3D%22%23000f66%22%20stroke-miterlimit%3D%2210%22%20stroke-width%3D%222.1%22%2F%3E%20%20%20%20%3Cpath%20d%3D%22M835.1%2C15.29h68.81v22.71h-41.55v25.57h34.82v20.19h-34.82v28.6h43.24v22.71h-70.49V15.29Z%22%20fill%3D%22aqua%22%20stroke%3D%22%23000f66%22%20stroke-miterlimit%3D%2210%22%20stroke-width%3D%222.1%22%2F%3E%3C%2Fsvg%3E";

var stopDragEventsPropagation = {
  onTouchMove: function onTouchMove(e) {
    return e.stopPropagation();
  },
  onTouchStart: function onTouchStart(e) {
    return e.stopPropagation();
  },
  onTouchEnd: function onTouchEnd(e) {
    return e.stopPropagation();
  },
  onPointerMove: function onPointerMove(e) {
    return e.stopPropagation();
  },
  onPointerUp: function onPointerUp(e) {
    return e.stopPropagation();
  },
  onPointerDown: function onPointerDown(e) {
    return e.stopPropagation();
  }
};
var mouseBlocker = _objectSpread(_objectSpread({}, stopDragEventsPropagation), {}, {
  onClick: function onClick(e) {
    return e.stopPropagation();
  },
  style: {
    position: 'fixed',
    zIndex: '1000',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    cursor: 'default'
  }
});
var propTypes = {
  defaultSigns: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    label: PropTypes$1.textElement
  })),
  signs: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    label: PropTypes$1.textElement,
    word: PropTypes$1.headingElement,
    description: PropTypes$1.textElement
  })),
  title: PropTypes$1.headingElement,
  description: PropTypes$1.textElement,
  author: PropTypes$1.authorElement,
  button: PropTypes$1.button,
  signSubtitle: PropTypes$1.headingElement,
  spacing: PropTypes.number,
  background: PropTypes$1.backgroundElement,
  popupBackground: PropTypes$1.backgroundElement,
  current: PropTypes.bool,
  preload: PropTypes.bool,
  type: PropTypes.string,
  className: PropTypes.string
};
var defaultProps = {
  defaultSigns: signs,
  signs: null,
  title: null,
  description: null,
  author: null,
  button: null,
  signSubtitle: null,
  spacing: 20,
  background: null,
  popupBackground: null,
  current: true,
  preload: true,
  type: 'horoscope',
  className: null
};
var UrbaniaHoroscope = function UrbaniaHoroscope(_ref) {
  var defaultSigns = _ref.defaultSigns,
    signsValue = _ref.signs,
    title = _ref.title,
    description = _ref.description,
    author = _ref.author,
    button = _ref.button,
    signSubtitle = _ref.signSubtitle,
    spacing = _ref.spacing,
    background = _ref.background,
    popupBackground = _ref.popupBackground,
    current = _ref.current,
    preload = _ref.preload,
    type = _ref.type,
    className = _ref.className;
  var intl = useIntl();
  var trackScreenEvent = useTrackScreenEvent(type);
  var _useViewerInteraction = useViewerInteraction(),
    enableInteraction = _useViewerInteraction.enableInteraction,
    disableInteraction = _useViewerInteraction.disableInteraction;
  var _usePlaybackContext = usePlaybackContext(),
    muted = _usePlaybackContext.muted;
  var mediaRef = usePlaybackMediaRef(current);
  var hasAuthor = author !== null && isTextFilled(author.name);
  var signs = useMemo(function () {
    return defaultSigns.map(function (defaultSign, index) {
      return _objectSpread(_objectSpread({}, signsValue !== null ? signsValue.find(function (_ref2) {
        var signValueId = _ref2.id;
        return signValueId === defaultSign.id;
      }) || signsValue[index] : null), defaultSign);
    });
  }, [signsValue]);
  var _useScreenSize = useScreenSize(),
    width = _useScreenSize.width,
    height = _useScreenSize.height,
    resolution = _useScreenSize.resolution;
  var _useViewerContext = useViewerContext(),
    viewerTopHeight = _useViewerContext.topHeight,
    viewerBottomHeight = _useViewerContext.bottomHeight;
  var _useScreenRenderConte = useScreenRenderContext(),
    isView = _useScreenRenderConte.isView,
    isPreview = _useScreenRenderConte.isPreview,
    isPlaceholder = _useScreenRenderConte.isPlaceholder,
    isEdit = _useScreenRenderConte.isEdit;
  var hasTitle = isTextFilled(title);
  var hasDescription = isTextFilled(description);
  var hasButton = isTextFilled(button);
  var backgroundPlaying = current && (isView || isEdit);
  var mediaShouldLoad = !isPlaceholder && (current || preload);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showSignsGrid = _useState2[0],
    setShowSignsGrid = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedSign = _useState4[0],
    setSelectedSign = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    showModal = _useState6[0],
    setShowModal = _useState6[1];
  var _ref3 = popupBackground || {},
    _ref3$video = _ref3.video,
    video = _ref3$video === void 0 ? null : _ref3$video;
  var _ref4 = video || {},
    _ref4$url = _ref4.url,
    popupBackgroundUrl = _ref4$url === void 0 ? null : _ref4$url;
  var onOpenSignsGrid = useCallback(function () {
    setShowSignsGrid(true);
    disableInteraction();
    trackScreenEvent('open');
  }, [disableInteraction, trackScreenEvent]);
  var onCloseSignsGrid = useCallback(function () {
    if (showModal) {
      setShowModal(false);
      return;
    }
    setShowSignsGrid(false);
    setShowModal(false); // can't have a modal if signs are closed
    enableInteraction();
    trackScreenEvent('close');
  }, [showModal, setShowSignsGrid, setShowModal, enableInteraction, trackScreenEvent]);
  var onSelectSign = useCallback(function (e, id) {
    e.stopPropagation();
    var foundSignIndex = signs.findIndex(function (s) {
      return s.id === id;
    });
    setSelectedSign(foundSignIndex);
    setShowModal(true);
    trackScreenEvent('select_sign', signs[foundSignIndex]);
  }, [signs, setSelectedSign, trackScreenEvent]);
  var onCloseModal = useCallback(function () {
    setShowModal(false);
    trackScreenEvent('close_sign');
  }, [setShowModal, trackScreenEvent]);
  var computeSignsGridProgress = useCallback(function (_ref5) {
    var dragActive = _ref5.active,
      _ref5$movement = _slicedToArray(_ref5.movement, 2),
      my = _ref5$movement[1],
      _ref5$velocity = _slicedToArray(_ref5.velocity, 2),
      vy = _ref5$velocity[1];
    // console.log({
    //     dragActive
    // });
    var progress = Math.max(0, my) / (window.innerHeight * 0.8);
    var reachedThreshold = vy > 0.3 || Math.abs(progress) > 0.3;
    if (!dragActive) {
      if (reachedThreshold) {
        onCloseSignsGrid();
      }
      return reachedThreshold ? 0 : 1;
    }
    return 1 - progress;
  }, [onCloseSignsGrid]);
  var _useDragProgress = useDragProgress({
      disabled: !isView,
      progress: showSignsGrid ? 1 : 0,
      computeProgress: computeSignsGridProgress,
      springParams: {
        config: {
          tension: 300,
          friction: 30
        }
      },
      dragOptions: {
        pointer: {
          keys: false
        }
      }
    }),
    bindSignsDrag = _useDragProgress.bind,
    showSignsGridProgress = _useDragProgress.progress;

  // console.log(showSignsGrid);

  var computeModalProgress = useCallback(function (_ref6) {
    var dragActive = _ref6.active,
      _ref6$movement = _slicedToArray(_ref6.movement, 2),
      my = _ref6$movement[1],
      _ref6$velocity = _slicedToArray(_ref6.velocity, 2),
      vy = _ref6$velocity[1];
    var damper = 0.5;
    var p = Math.max(0, my) / window.innerHeight;
    var progress = p * damper;
    var reachedThreshold = vy > 0.3 || Math.abs(p) > 0.3;
    if (!dragActive) {
      if (reachedThreshold) {
        onCloseModal();
      }
      return reachedThreshold ? 0 : 1;
    }
    return 1 - progress;
  }, [showModal, onCloseModal]);
  var _useDragProgress2 = useDragProgress({
      disabled: !isView,
      progress: showModal ? 1 : 0,
      computeProgress: computeModalProgress,
      springParams: {
        config: {
          tension: 300,
          friction: 30
        }
      },
      dragOptions: {
        pointer: {
          keys: false
        }
      }
    }),
    bindModalDrag = _useDragProgress2.bind,
    showModalProgress = _useDragProgress2.progress;
  var getHeaderStyles = function getHeaderStyles(spring) {
    return {
      transform: spring.to(function (p) {
        return "translateY(".concat(-100 * p * (1 - p), "%)");
      }),
      opacity: spring.to(function (p) {
        return p > 0.25 ? 1 - p : 1;
      })
    };
  };
  var getSignsContainerStyles = function getSignsContainerStyles(spring) {
    return {
      opacity: spring,
      pointerEvents: spring.to(function (p) {
        return p < 0.25 ? 'none' : 'auto';
      })
    };
  };
  var getSignStyles = function getSignStyles(spring) {
    return {
      opacity: spring,
      transform: spring.to(function (p) {
        return "translateY(".concat(3 * Math.pow(1 - p, 5), "rem) scale(").concat(1 - 0.25 * (1 - p), ")");
      })
    };
  };
  var getAuthorStyles = function getAuthorStyles(spring) {
    return {
      transform: spring.to(function (p) {
        return "translateY(".concat(2 * (1 - p), "rem)");
      }),
      opacity: spring
    };
  };
  var getBackdropStyles = function getBackdropStyles(spring) {
    return {
      opacity: spring
    };
  };
  var getModalStyles = function getModalStyles(spring) {
    return {
      transform: spring.to(function (p) {
        return "translateY(".concat(100 * (1 - (p < 0.2 ? 0.1 * p + p : p)), "%)");
      }),
      pointerEvents: spring.to(function (p) {
        return p < 0.1 ? 'none' : 'auto';
      })
    };
  };

  // for editor purposes
  var screenState = useScreenState();
  useEffect(function () {
    setShowSignsGrid(false);
    if (screenState === null || screenState === 'intro') {
      setShowSignsGrid(false);
      setShowModal(false);
    }
    if (screenState === 'grid') {
      setShowSignsGrid(true);
      setSelectedSign(null);
      setShowModal(false);
    }
    if (screenState !== null && screenState.includes('signs')) {
      var index = screenState.split('.').pop();
      setShowSignsGrid(true);
      setShowModal(true);
      setSelectedSign(index);
    }
  }, [screenState, setShowSignsGrid, setShowModal, setSelectedSign]);
  useEffect(function () {
    var keyup = function keyup(e) {
      if (e.key === 'Escape') {
        if (showModal) {
          onCloseModal();
          return;
        }
        if (showSignsGrid) {
          onCloseSignsGrid();
        }
      }
    };
    document.addEventListener('keyup', keyup);
    return function () {
      document.removeEventListener('keyup', keyup);
    };
  }, [showModal, onCloseModal, showSignsGrid, onCloseSignsGrid]);
  return /*#__PURE__*/React.createElement("div", Object.assign({
    className: classNames([styles.container, _defineProperty(_defineProperty({}, className, className !== null), styles.isPlaceholder, isPlaceholder)]),
    "data-screen-ready": true
  }, showSignsGrid ? stopDragEventsPropagation : null), !isView ? /*#__PURE__*/React.createElement("div", mouseBlocker) : null, /*#__PURE__*/React.createElement(Container, {
    width: width,
    height: height,
    className: styles.content
  }, /*#__PURE__*/React.createElement(Layout, {
    className: styles.layout,
    style: !isPlaceholder ? {
      padding: spacing,
      paddingTop: (!isPreview ? viewerTopHeight : 0) + spacing,
      paddingBottom: (current && !isPreview ? viewerBottomHeight : 0) + spacing
    } : null,
    height: height * 0.8
  }, isPlaceholder ? /*#__PURE__*/React.createElement("div", {
    className: styles.placeholderGrid
  }, _toConsumableArray(Array(12).keys()).map(function () {
    return /*#__PURE__*/React.createElement("div", {
      className: styles.placeholderItem
    });
  })) : null, /*#__PURE__*/React.createElement(animated.div, {
    className: styles.headerContainer,
    style: getHeaderStyles(showSignsGridProgress)
  }, /*#__PURE__*/React.createElement(ScreenElement, {
    emptyClassName: styles.emptyText
  }, hasTitle ? /*#__PURE__*/React.createElement(Heading, Object.assign({
    className: styles.title
  }, title)) : /*#__PURE__*/React.createElement("img", {
    src: Astrologie,
    alt: "",
    className: styles.titleImage
  })), /*#__PURE__*/React.createElement(ScreenElement, {
    key: "description",
    emptyLabel: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "EQdIAR",
      defaultMessage: [{
        "type": 0,
        "value": "Description"
      }]
    }),
    emptyClassName: styles.emptyText,
    isEmpty: !hasDescription
  }, hasDescription ? /*#__PURE__*/React.createElement(Text, Object.assign({
    className: styles.description
  }, description)) : null)), /*#__PURE__*/React.createElement(ScreenElement, {
    emptyLabel: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "bv3rRe",
      defaultMessage: [{
        "type": 0,
        "value": "Button"
      }]
    }),
    emptyClassName: styles.emptyText,
    isEmpty: !hasButton
  }, hasButton ? /*#__PURE__*/React.createElement(Button, Object.assign({
    className: styles.button,
    type: "button",
    onClick: onOpenSignsGrid,
    withoutBootstrapStyles: true,
    focusable: current && !isPreview && !isPlaceholder
  }, button), /*#__PURE__*/React.createElement(Text, Object.assign({
    className: styles.buttonLabel
  }, button, {
    inline: true
  }))) : null), isView && !isPlaceholder ? /*#__PURE__*/React.createElement(animated.div, {
    className: styles.header,
    style: {
      opacity: showSignsGridProgress,
      pointerEvents: showSignsGridProgress.to(function (p) {
        return p < 0.25 ? 'none' : 'auto';
      })
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.buttons
  }, /*#__PURE__*/React.createElement(Button, {
    className: styles.close,
    onClick: onCloseSignsGrid,
    label: intl.formatMessage({
      id: "dj/p/q",
      defaultMessage: [{
        "type": 0,
        "value": "Close"
      }]
    }),
    iconPosition: "right",
    icon: /*#__PURE__*/React.createElement("svg", {
      className: styles.closeIcon,
      xmlns: "http://www.w3.org/2000/svg",
      width: "10",
      height: "16",
      viewBox: "0 0 10 16",
      fill: "currentColor"
    }, /*#__PURE__*/React.createElement("polygon", {
      points: "9.95 4.11 8.89 3.05 5 6.94 1.11 3.05 0.05 4.11 3.94 8 0.05 11.89 1.11 12.95 5 9.06 8.89 12.95 9.95 11.89 6.06 8 9.95 4.11"
    })),
    focusable: !isPreview && !isPlaceholder && (showSignsGrid || showModal),
    withoutStyle: true
  }))) : null, !isPlaceholder ? /*#__PURE__*/React.createElement(animated.div, Object.assign({
    className: styles.signsGridContainer,
    style: getSignsContainerStyles(showSignsGridProgress)
  }, bindSignsDrag()), /*#__PURE__*/React.createElement(Keypad, {
    columns: 3,
    spacing: 5,
    withoutCloseButton: true,
    items: signs.map(function (sign) {
      var _ref8 = sign || {},
        _ref8$id = _ref8.id,
        id = _ref8$id === void 0 ? null : _ref8$id;
      return /*#__PURE__*/React.createElement(animated.div, {
        key: id,
        className: styles.sign,
        style: getSignStyles(showSignsGridProgress)
      }, /*#__PURE__*/React.createElement(SignCard, {
        key: id,
        sign: sign,
        focusable: !isPreview && !isPlaceholder && showSignsGrid && !showModal,
        onClick: function onClick(e) {
          return onSelectSign(e, id);
        }
      }));
    })
  }), /*#__PURE__*/React.createElement(ScreenElement, {
    key: "author",
    emptyLabel: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "xYqGzM",
      defaultMessage: [{
        "type": 0,
        "value": "Author"
      }]
    }),
    emptyClassName: styles.emptyText,
    isEmpty: !hasAuthor
  }, hasAuthor && !isPlaceholder ? /*#__PURE__*/React.createElement(Author, {
    author: author,
    className: styles.author,
    collaboratorClassName: styles.collaborator,
    backgroundClassName: styles.authorBackground,
    shouldLoad: mediaShouldLoad,
    style: getAuthorStyles(showSignsGridProgress)
  }) : null)) : null, /*#__PURE__*/React.createElement(animated.div, Object.assign({
    className: styles.modal,
    style: getModalStyles(showModalProgress)
  }, bindModalDrag()), /*#__PURE__*/React.createElement(SignModal, {
    width: width,
    height: height,
    sign: signs[selectedSign],
    subtitle: signSubtitle,
    focusable: !isPreview && !isPlaceholder && showModal,
    onClick: onCloseModal
  })), !isPlaceholder ? /*#__PURE__*/React.createElement(animated.div, {
    className: styles.backdrop,
    style: getBackdropStyles(showSignsGridProgress)
  }, popupBackgroundUrl !== null ? /*#__PURE__*/React.createElement("video", {
    className: styles.videoBackdrop,
    autoPlay: true,
    muted: true,
    loop: true,
    playsInline: true
  }, /*#__PURE__*/React.createElement("source", {
    src: popupBackgroundUrl,
    type: "video/mp4"
  })) : null) : null)), !isPlaceholder ? /*#__PURE__*/React.createElement(Background, {
    background: background,
    width: width,
    height: height,
    resolution: resolution,
    playing: backgroundPlaying,
    muted: muted,
    shouldLoad: mediaShouldLoad,
    mediaRef: mediaRef,
    className: styles.background
  }) : null);
};
UrbaniaHoroscope.propTypes = propTypes;
UrbaniaHoroscope.defaultProps = defaultProps;

var definition = [{
  id: 'urbania-horoscope',
  type: 'screen',
  namespaces: ['urbania', 'bayard'],
  group: {
    label: defineMessage({
      id: "oPjl8f",
      defaultMessage: [{
        "type": 0,
        "value": "Urbania"
      }]
    }),
    order: 10
  },
  title: defineMessage({
    id: "F59wsl",
    defaultMessage: [{
      "type": 0,
      "value": "Urbania horoscope"
    }]
  }),
  component: UrbaniaHoroscope,
  states: [{
    id: 'intro',
    label: defineMessage({
      id: "82g1F5",
      defaultMessage: [{
        "type": 0,
        "value": "Intro"
      }]
    }),
    fields: [{
      name: 'title',
      type: 'heading-element',
      label: defineMessage({
        id: "N25iDO",
        defaultMessage: [{
          "type": 0,
          "value": "Title"
        }]
      })
    }, {
      name: 'description',
      type: 'text-element',
      label: defineMessage({
        id: "Y7bs1v",
        defaultMessage: [{
          "type": 0,
          "value": "Description"
        }]
      })
    }, {
      name: 'button',
      type: 'button-element',
      label: defineMessage({
        id: "i6bmbD",
        defaultMessage: [{
          "type": 0,
          "value": "Button"
        }]
      })
    }, {
      name: 'background',
      type: 'background',
      label: defineMessage({
        id: "+MPZRu",
        defaultMessage: [{
          "type": 0,
          "value": "Background"
        }]
      })
    }]
  }, {
    id: 'grid',
    label: defineMessage({
      id: "xj0o1v",
      defaultMessage: [{
        "type": 0,
        "value": "Grid"
      }]
    }),
    fields: [{
      name: 'popupBackground',
      type: 'background',
      label: defineMessage({
        id: "+MPZRu",
        defaultMessage: [{
          "type": 0,
          "value": "Background"
        }]
      })
    }, {
      name: 'author',
      type: 'author-element',
      label: defineMessage({
        id: "73hxYw",
        defaultMessage: [{
          "type": 0,
          "value": "Author"
        }]
      })
    }]
  }, {
    id: 'signs',
    label: defineMessage({
      id: "ap68Fp",
      defaultMessage: [{
        "type": 0,
        "value": "Signs"
      }]
    }),
    defaultValue: signs,
    repeatable: true,
    withoutCreate: true,
    fieldName: 'signs',
    fields: [{
      name: 'word',
      type: 'heading-element',
      label: defineMessage({
        id: "fLdjGi",
        defaultMessage: [{
          "type": 0,
          "value": "Word of the week"
        }]
      })
    }, {
      name: 'description',
      type: 'text-element',
      label: defineMessage({
        id: "ZCe0r4",
        defaultMessage: [{
          "type": 0,
          "value": "Description"
        }]
      })
    }]
  }],
  fields: [{
    name: 'signSubtitle',
    type: 'heading-element',
    defaultValue: {
      body: 'Le mot de la semaine'
    },
    label: defineMessage({
      id: "Qe03Xz",
      defaultMessage: [{
        "type": 0,
        "value": "Sign Subtitle"
      }]
    })
  }, {
    name: 'background',
    type: 'background',
    label: defineMessage({
      id: "+MPZRu",
      defaultMessage: [{
        "type": 0,
        "value": "Background"
      }]
    })
  }]
}];

export { UrbaniaHoroscope, definition as default, signs };
